import Immutable from 'immutable';
import { CHAT_SET_NUM_UNREAD_CONVERSATIONS } from './actions';

/*
WARNING:
This entire store is a cop out from refactoring chat into react-redux from the jquery
event handler mess that it is. It needs to be replaced with something that stores messages
and conversations, at the moment its just a few hacks to reference bits of chat data from react
*/

const INITIAL_STATE = Immutable.fromJS({
  numUnreadConversations: 0,
});

export function Chat(state = INITIAL_STATE, action = { type: null }) {
  switch (action.type) {
    case CHAT_SET_NUM_UNREAD_CONVERSATIONS: {
      return state.set('numUnreadConversations', action.numUnreadConversations);
    }
    default: {
      return state;
    }
  }
}
